import connectFormikField from '../connectFormikField/connectFormikField'
import InputDropdown from '@/redesign/components/InputDropdown/InputDropdown'

const FormikDropdown = connectFormikField(InputDropdown)

export default FormikDropdown
